export enum PaymentType {
  bill = 'bill',
  deposit = 'deposit',
}

export namespace PaymentType {
  export const translateType = (type: PaymentType): string => {
    switch (type) {
      case PaymentType.bill:
        return "Boleto"
      case PaymentType.deposit:
        return "Depósito";
      default: return "";
    };
  };

  export const paymentTypeChoices: Array<{ id: string, name: string }> = Object.values(PaymentType)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: PaymentType.translateType(type as PaymentType),
    } as { id: string, name: string }));
};
